module.exports = __webpack_public_path__ + "MSC_Swedish_Portrait_Blue_RGB-f470c83eb978faf7dfe57acd38140185.png";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/product-labels/MSC_Swedish_Portrait_Blue_RGB.png
// module id = 74
// module chunks = 0